import React from 'react';

const MongoDB_NodeJSDriver = () => {
  return (
    <div>
      <h1>MongoDB_NodeJSDriver Component</h1>
      <p>This is the MongoDB_NodeJSDriver page.</p>
    </div>
  );
};

export default MongoDB_NodeJSDriver;
